import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-device-monitor',
  templateUrl: './icon-device-monitor.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconDeviceMonitorComponent {}
